import React, { useState, useEffect } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx';
import axios from 'axios';
import moment from 'moment';
import { s2ab, canBeViewedWeb } from '../ReactGlobals.js';
import { ajax_api } from '../../Globals.jsx';
import { useOutlet, Outlet } from 'react-router-dom';
import RagnaModal from '../ReactComponents/RagnaModal.jsx';
import RagnaLoader from '../ReactComponents/RagnaLoader.jsx';
import { Helmet } from 'react-helmet';
import { RMultiTab } from '../ReactComponents/RMultiTab.jsx';
import RichTextEditor from '../ReactComponents/RichTextEditor';
import { Document, Page, pdfjs } from 'react-pdf';

const Legislations = props => {
    const [codeItemType, setCodeItemType] = useState([]);// props.codeItemType;
    const [codeSession, setCodeSession] = useState([]);
    const [codeCouncil, setCodeCouncil] = useState([]);
    const [codeAuthor, setCodeAuthor] = useState([]);
    const [codeCoAuthor, setCodeCoAuthor] = useState([]);
    const [codeCategory, setCodeCategory] = useState([]);
    const [codeCommittee, setCodeCommittee] = useState([]);
    const [codeStatuses, setCodeStatuses] = useState([]);
    const maxTitleLength = 99999;

    const [existingDocUrl, setExistingDocUrl] = useState("");
    const [attachmentsUrl, setAttachmentsUrl] = useState([]);
    const [scannedUrl, setScannedUrl] = useState();


    const [loaded, setLoaded] = useState(false);
    const [currentPdfPage, setCurrentPdfPage] = useState(1);
    const [numPages, setNumPages] = useState(0);

    //new shayt
    const [titleKeyword, setTitleKeyword] = useState("");
    const [generalSearchKeyword, setGeneralSearchKeyword] = useState("");
    const [itemContentKeyword, setItemContentKeyword] = useState([]);

    const addHighlight = (text, keywords, indent = false) => {
        if (keywords.length === 0) {
            return text;
        }
        keywords = keywords.filter(k => k != "");
        indent = false;
        const indentKeywords = ["Authored by:", "WHEREAS,", "SECTION", "xxx xxx xxx", "Hon."]

        var _text = [];

        if (indent) {
            let regIndent = new RegExp(indentKeywords.join("|"), 'g');
            const _indentArr = text.split(regIndent);
            const _indentMatches = text.match(regIndent);

            _indentArr.forEach((ie, ii) => {
                //highlight it first!
                var currentStart = 0;

                let re = new RegExp(keywords.join("|"), 'g'); //.toUpperCase()

                const _arr = ie.toUpperCase().split(re);
                const _matches = ie.toUpperCase().match(re);

                var innerText = [];

                _arr.forEach((s, i) => {
                    var k = _matches == null ? "" : _matches[i] ?? "";
                    if (k === undefined)
                        innerText.push(<span>{ie.substring(currentStart)}</span>);
                    else {
                        innerText.push(<span>
                            <span>{ie.substring(currentStart, currentStart + s.length)}</span>
                            {
                                i < _arr.length - 1 ?
                                    <span style={{ background: "yellow", fontWeight: "bold", color: "black" }}>{ie.substring(currentStart + s.length, currentStart + s.length
                                        + k.length)}</span>
                                    : ""
                            }
                        </span>);
                        currentStart += s.length + k.length;
                    }

                })
                _text.push(<span>
                    {
                        innerText.map(t => <>
                            <span>{t}</span>{_indentMatches[ii]}</>)
                    }
                </span>)
            })



        } else {
            var currentStart = 0;

            var _capText = text.toUpperCase();
            let re = new RegExp(keywords.join("|").toUpperCase(), 'g');

            const _arr = _capText.split(re);
            const _matches = _capText.match(re);

            _arr.forEach((s, i) => {
                var k = _matches != null ? _matches[i] : undefined;
                if (k === undefined)
                    _text.push(<span>{text.substring(currentStart)}</span>);
                else {
                    _text.push(<span>
                        <span>{text.substring(currentStart, currentStart + s.length)}</span>
                        {
                            i < _arr.length - 1 ?
                                <span style={{ background: "yellow", fontWeight: "bold", color: "black" }}>{text.substring(currentStart + s.length, currentStart + s.length
                                    + k.length)}</span>
                                : ""
                        }
                    </span>);
                    currentStart += s.length + k.length;
                }

            })

        }
        return <span>{_text.map(t => <span>{t}</span>)}</span>;
    }

    const addHighlightLongString = (text, keywords, maxLength = 99999999999, indent = false) => {
        if (keywords == null || keywords == "" || keywords.length == 0)
            return text.length > maxLength ? text.substring(0, maxLength).trim() + "..." : text;

        keywords = keywords.filter(k => k != "");
        if (text.length > maxLength) {
            //trim
            var keyword = keywords[0];
            var splitted = text.toUpperCase().split(keyword.toUpperCase());
            console.log(splitted)

            if (splitted.length === 1) {
                return addHighlight(text, keywords, indent)
            } else {
                var median = (maxLength - keyword.length) / 2;
                var startingIndex = splitted[0].length + keyword.length;

                var trueStartingIndex = (startingIndex - median) < 0 ? 0 : (startingIndex - median);
                //alert("ASD")
                return addHighlight((trueStartingIndex > 0 ? "..." : "") + (text.substring(trueStartingIndex, startingIndex + median)).trim() + "...", keywords, indent)
            }
        } else {
            return addHighlight(text, keywords, indent)
        }
    }

    useEffect(_ => {
        axios.get(ajax_api + "items/getOptions")
            .then(response => {
                return response.data
            })
            .then(d => {
                setCodeItemType(d.itemTypes)
                setCodeSession([{ label: "No Session", value: -1 }, ...d.sessions])
                setCodeCouncil([{ label: "No Council", value: -1 }, ...d.councils])
                setCodeAuthor([{ label: "No Authors", value: -1 }, ...d.officials])
                setCodeCoAuthor([{ label: "No CoAuthors", value: -1 }, ...d.officials])
                setCodeCategory([{ label: "No Category", value: -1 }, ...d.categories])
                setCodeCommittee([{ label: "No Committee", value: -1 }, ...d.committees])
                setCodeStatuses([{ label: "Untracked", value: -1 }, ...d.trackingStatuses])
            })
            .catch(error => {
                console.log(error.response.data.error)
            })
    }, [])

    //datatable options
    const table_columns = [
        //{ display: "ID", col: "Id" },
        {
            display: "Item Code", col: "ItemCode", customValue: v => {
                return addHighlightLongString(v.ItemCode, [generalSearchKeyword])
            } },
        {
            display: "Title", col: "Title", lg: true, customStyle: {width: "70%"}, customValue: v => {
                return addHighlightLongString(v.Title, [titleKeyword, generalSearchKeyword]);
            }
        },
        //{ display: "Enacted Date", col: "EnactedDate", customValue: e => e.EnactedDate ? moment(e.EnactedDate).format("MMMM D, YYYY") : "null" },
    ];
    const search_columns = [
        { display: "Title", col: "Title", keyword: false },
        { display: "Item Content", col: "ItemContent", keyword: true },
        { display: "Item Code", col: "ItemCode" },
        {
            display: "Item Type", col: "ItemType", options: codeItemType, blankOption: "[Match any]",
            customValue: v => codeItemType.filter(x => x.value === v)[0].display
        },
        { display: "Date Enacted", col: "EnactedDate", dateRange: true },
        { display: "Date Approved", col: "ApprovedDate", dateRange: true },
        //{ display: "Approved", col: "IsApproved", options: [{ value: true, label: "Yes" }, { value: false, label: "No" }], blankOption: "[Match any]" },
        {
            display: "Council", col: "CouncilId", options: codeCouncil, blankOption: "[Match any]", customValue:
                v => codeCouncil.filter(x => x.value === v)[0].display
        },
        {
            display: "Session", col: "SessionId", options: codeSession, blankOption: "[Match any]", customValue:
                v => codeSession.filter(x => x.value === v)[0].display
        },
        {
            display: "Author", col: "AuthorId", options: codeAuthor, blankOption: "[Match any]", customValue:
                v => codeAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "Main Author (Sole)", col: "SoleAuthor", options: codeAuthor, blankOption: "[Match any]", customValue:
                v => codeAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "Author (Multiple)", col: "AuthorList", options: codeAuthor, blankOption: "[Match any]", customValue:
                v => codeAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "CoAuthor", col: "Officials", options: codeCoAuthor, blankOption: "[Match any]", customValue:
                v => codeCoAuthor.filter(x => x.value === v)[0].display
        },
        {
            display: "Category", col: "Categories", options: codeCategory, blankOption: "[Match any]", customValue:
                v => codeCategory.filter(x => x.value === v)[0].display
        },
        {
            display: "Committee", col: "Committees", options: codeCommittee, blankOption: "[Match any]", customValue:
                v => codeCommittee.filter(x => x.value === v)[0].display
        },
        //{
        //    display: "Tracking Status", col: "TrackingStatusSpitems", options: codeStatuses, blankOption: "[Match any]", customValue:
        //        v => codeStatuses.filter(x => x.value === v)[0].display
        //},
    ];
    const outlet = useOutlet();

    const [modalOpen, setModalOpen] = useState(false);
    const [excerpt, setExcerpt] = useState();
    const [councilMembers, setCouncilMembers] = useState();

    const getExcerpt = id => {
        axios.get(`${ajax_api}items?id=${id}`).then(d => {
            setExcerpt(d.data);
        }).catch(`fetch excerpt error.. ${console.log}`);
    }

    const getMembers = id => {
        axios.get(`${ajax_api}main/get-official-types/${id}`).then(d => {
            setCouncilMembers(d.data);
        }).catch(`fetch excerpt error.. ${console.log}`);
    }

    //const

    const detailsModal = <RagnaModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        noBtn={true}
        closeAndThen={_ => {
            setExcerpt(null);
            setCouncilMembers(null);
        }}
        width={excerpt == null ? null : 900}
        boxStyle={{ minHeight: 0 }}
        body={<>
            {
                excerpt == null ? <RagnaLoader /> :
                    //<RMultiTab contents={[
                    //    {
                    //        title: <><i className="fa fa-list" /> Details</>,
                    //        content:
                    //            <div style={{ padding: 15, overflow: "hidden auto", maxHeight: 500 }}>
                    //                <div className="row mb-3" style={{ fontSize: "1.2em" }}>
                    //                    <div className="col-7">
                    //                        {excerpt.ItemType} No. {excerpt.ItemCode}
                    //                    </div>
                    //                    <div className="col">
                    //                        Enacted Date: {moment(excerpt.EnactedDate).format("MMMM DD, YYYY")}
                    //                    </div>
                    //                </div>
                    //                <hr />
                    //                {
                    //                    councilMembers == null ? "{Loading members..}" :
                    //                        (councilMembers.length === 0 ? (excerpt.Committee?.length > 0 ? excerpt.Committee[0] : <>-no authors found-</>)
                    //                            : councilMembers.map(m =>
                    //                                <div className="row">
                    //                                    <div className="col">
                    //                                        {m.Name}
                    //                                    </div>
                    //                                    <div className="col">
                    //                                        {m.Type}
                    //                                    </div>
                    //                                </div>
                    //                            ))
                    //                }
                    //                <div className="row m-0 mt-4" style={{ textIndent: 60 }}>
                    //                    {excerpt.Title}
                    //                </div>
                    //                <hr />
                    //                <div className="row m-0" style={{ textIndent: 60 }}>
                    //                    {excerpt.ItemContent}
                    //                </div>
                    //            </div>
                    //    },
                    //    {
                    //        title: <><i className="fa fa-book"></i> Document Viewer</>,
                    //        content: <>
                    //            {
                    //                excerpt?.DocEditorContent == "" ? <span className="text-danger"><i className='fa fa-warning' /> Document is blank</span> :
                    //                    <RichTextEditor
                    //                        initialValue={excerpt?.DocEditorContent ?? ""}
                    //                        readOnly={true} />
                    //            }

                    //        </>
                    //    },
                    //    {
                    //        title: <><i className="fa fa-book"></i> File Attachments</>,
                    //        content: <>
                    //            <div>
                    //                <b>Document File:</b> <br/>
                    //                {
                    //                    excerpt.DocumentFileName == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER</div> :
                    //                        (excerpt.FilePath && excerpt.FilePath != "" ?
                    //                            <a href={existingDocUrl} download={
                    //                                canBeViewedWeb(excerpt.DocumentFileName.split(".").pop())
                    //                                    ? null : excerpt.ItemType+"-"+excerpt.ItemCode+"-Document."+excerpt.DocumentFileName.split(".").pop()//excerpt.DocumentFileName
                    //                            } target="blank"><i className={canBeViewedWeb(excerpt.DocumentFileName.split(".").pop()) ? 'fa fa-external-link' : 'fa fa-download'}></i> {excerpt.ItemType+"-"+excerpt.ItemCode+"-Document."+excerpt.DocumentFileName.split(".").pop()}</a>
                    //                            : "-no uploaded file-")
                    //                }
                    //            </div>
                    //            <div className="mt-2">
                    //                <b>Additional File/s:</b> <br/>
                    //                {
                    //                    excerpt.Attachments == null || excerpt.Attachments.length === 0 ? "No additional attachments" : ""
                    //                }
                    //                {
                    //                    excerpt.Attachments?.map((attachment,index)=>{
                    //                        var url = attachmentsUrl[index];
                    //                        var filename = attachment.filename;
                    //                        var guid_length = 36;
                    //                        var get_short = excerpt.ItemType.split(" ").map(s=>s[0]).join("");
                    //                        var filename_start_length = `${get_short}-${excerpt.ItemCode}-attachment-`.length + guid_length;
                    //                        var filename_fixed = filename.substring(filename_start_length);
                    //                        if(url == undefined) return;

                    //                        return <div key={`attachment-${index}`}>
                    //                            {
                    //                                filename == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER. UNABLE TO RETRIEVE THIS FILE.</div> :
                    //                                    <a href={url} download={
                    //                                        canBeViewedWeb(filename.split(".").pop())
                    //                                            ? null : filename_fixed
                    //                                    } target="blank"><i className={canBeViewedWeb(filename.split(".").pop()) ? 'fa fa-external-link' : 'fa fa-download'}></i> {filename_fixed}</a>

                    //                            }
                    //                        </div>
                    //                    })
                    //                }
                    //            </div>
                    //        </>
                    //    },
                    //    {
                    //        title: <><i className="fa fa-book"></i> Scanned Document</>,
                    //        content: <>
                    //            {
                    //                excerpt.ScannedFileName == "disconnected" ? <div className="text-danger fw-bold"><i className="fa fa-exclamation-triangle" /> UNABLE TO CONNECT TO FTP SERVER</div> :
                    //                    (
                    //                        excerpt.ScannedFileName.split(".").pop() == "pdf" ?
                    //                            (
                    //                                <>
                    //                                    {
                    //                                        //view pdf on new tab (for printing)
                    //                                        <a href={scannedUrl} target="blank"><i className="fa fa-print"></i> {excerpt.ItemType+"-"+excerpt.ItemCode+"-Scanned."+excerpt.ScannedFileName.split(".").pop()}</a>
                    //                                    }
                    //                                    {
                    //                                        //scanned document pagination navigation (?)
                    //                                        <div className='pt-2 text-center mb-2'>
                    //                                            <button className='btn btn-secondary'
                    //                                                disabled={currentPdfPage <= 1}
                    //                                                onClick={_ => setCurrentPdfPage(p => p == 1 ? 1 : p - 1)}>PREV</button>
                    //                                            <span className='mx-2'>
                    //                                                Page {currentPdfPage} of {numPages}
                    //                                            </span>
                    //                                            <button className='btn btn-secondary'
                    //                                                disabled={currentPdfPage >= numPages}
                    //                                                onClick={_ => setCurrentPdfPage(p => p >= numPages ? numPages : p + 1)}>NEXT</button>

                    //                                        </div>
                    //                                    }
                    //                                    <Document
                    //                                        onLoadError={console.error}
                    //                                        file={scannedUrl}
                    //                                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    //                                        className="import-pdf-page bg-secondary p-2 d-flex justify-content-center"
                    //                                        style={{
                    //                                            background: '#ccc'
                    //                                        }}
                    //                                    >
                    //                                        {
                    //                                            (Array.apply(null, Array(numPages))
                    //                                                .map((x, i) => i + 1))
                    //                                                .map(page => {
                    //                                                    return <>
                    //                                                        <Page
                    //                                                            className={
                    //                                                                (page != currentPdfPage ? "d-none" : "")
                    //                                                                + " shadow-lg"}
                    //                                                            pageNumber={page}
                    //                                                            key={`scanned-page-${page}`} />
                    //                                                    </>
                    //                                                })

                    //                                        }
                    //                                    </Document>
                    //                                </>
                    //                            ) :
                    //                        <img src={`data:image/png;base64,${excerpt.ItemScan != "" ? excerpt.ItemScan :
                    //                        excerpt.ItemScanUrl}`} alt="scanned_photo" />
                    //                    )
                    //            }
                    //        </>
                    //    }
                    //] } />
                    <div style={{ padding: 15, overflow: "hidden auto", maxHeight: 500 }}>
                        <div className="row mb-3" style={{ fontSize: "1.2em" }}>
                            <div className="col-7">
                                {excerpt.ItemType} No. {generalSearchKeyword !== "" ? addHighlight(excerpt.ItemCode, [generalSearchKeyword]) : excerpt.ItemCode}
                            </div>
                            <div className="col">
                                Enacted Date: {moment(excerpt.EnactedDate).format("MMMM DD, YYYY")}
                            </div>
                        </div>
                        <hr />
                        {
                            councilMembers == null ? "{Loading members..}" :
                                (councilMembers.length === 0 ? (excerpt.Committee?.length > 0 ? excerpt.Committee[0] : <>-no authors found-</>)
                                    : councilMembers.map(m =>
                                        <div className="row">
                                            <div className="col">
                                                {m.Name}
                                            </div>
                                            <div className="col">
                                                {m.Type}
                                            </div>
                                        </div>
                                    ))
                        }
                        <div className="row m-0 mt-4" style={{ textIndent: 60 }}>
                            {
                                addHighlight(excerpt.Title, [titleKeyword, generalSearchKeyword]
                                    //titleKeyword !== "" ?
                                    //    (
                                    //        generalSearchKeyword == "" ?
                                    //            [titleKeyword] :
                                    //            [generalSearchKeyword, titleKeyword]
                                    //    ) :
                                    //    (
                                    //        generalSearchKeyword !== "" ?
                                    //            [generalSearchKeyword] :
                                    //            []
                                    //    )
                                )
                            }
                        </div>
                        <hr />
                        <div className="row m-0" style={{ whiteSpace: "pre-wrap" }}>
                            {addHighlight(excerpt.ItemContent, itemContentKeyword, true)}
                        </div>
                    </div>
            }
        </>}
    />



    useEffect(_ => {
        if (excerpt != null) {
            var docUrl = "";
            var scanUrl = "";
            var arr = [];

            if (excerpt.FilePath) {
                var file;
                var fileExtension = excerpt.DocumentFileName.split(".").pop();
                var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                file = new Blob([s2ab(atob(excerpt.FilePath))], { type: fileType });
                docUrl = URL.createObjectURL(file);
                setExistingDocUrl(docUrl);
                // free memory when ever this component is unmounted
            }
            if (excerpt.ItemScan) {
                var file;
                var fileExtension = excerpt.ScannedFileName.split(".").pop();
                var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                file = new Blob([s2ab(atob(excerpt.ItemScan))], { type: fileType });
                scanUrl = URL.createObjectURL(file);
                setScannedUrl(scanUrl);
                // free memory when ever this component is unmounted
            }
            //set file attachments
            if (excerpt.Attachments) {
                (async function () {
                    await excerpt.Attachments.forEach(attachment => {
                        var file;
                        var fileExtension = attachment.filename.split(".").pop();
                        var fileType = fileExtension == 'pdf' ? "application/pdf" : "image/" + fileExtension;

                        file = new Blob([s2ab(atob(attachment.file))], { type: fileType });
                        arr.push(URL.createObjectURL(file));
                    })
                })();
                setAttachmentsUrl(arr);
            }
            setLoaded(true);
            return _ => {
                URL.revokeObjectURL(docUrl);
                URL.revokeObjectURL(scanUrl);
                arr.forEach(u => URL.revokeObjectURL(u))
            }
        }
    }, [excerpt])

    return <>
        <Helmet>
            <title>LTS | Legislations</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                <>
                    {detailsModal}
                    <RagnaDataTable
                        generalSearch={true}
                        customEntrySizes={[5, 10, 50, 100, 1000]}
                        title="SP Items"
                        columns={table_columns}
                        s_columns={search_columns}
                        defaultOrder={false}
                        maxPagination={8}
                        defaultOrderCol="Id"
                        url={ajax_api + "items/dtable"}//LTS/getSPItems
                        multiFilter={true}
                        multiFilterWidth={900}
                        multiFilterDivs={2}
                        multiFilterHeader={
                            <div className="alert alert-warning mb-1">
                                To search / filter for <b>ITEM CONTENT</b> keywords:
                                <ol>
                                    <li>Click on the input box for Item Content, (Input keywords)</li>
                                    <li>Type in a keyword.</li>
                                    <li>Press the <b>ENTER</b> key to register a keyword.</li>
                                    <li>Type again a keyword to register another one.</li>
                                </ol>
                                * To remove a keyword, press the <b>X</b> button beside the keyword, or press the <b>X</b> button at the far right of the input box.
                            </div>
                        }
                        multiFilterHideInputIf={{
                            col: "SoleAuthor",
                            condition: "!=",
                            value: -1,
                            colsToBeHidden: ["AuthorList", "Officials"]
                        }}
                        multiFilterFilterOptions={(currentCol, values, options) => {
                            if (["SoleAuthor", "AuthorList", "Officials", "Committees"].includes(currentCol)) {
                                if (values.CouncilId != "" && values.CouncilId != -1) {
                                    return options.filter(c => c.councilIds == null || c.councilIds.includes(values.CouncilId));
                                }
                            }
                            return options
                        }}
                        onFilter={filter => {
                            if (filter.Title != null) {
                                //hightlight title
                                setTitleKeyword(filter.Title);
                            } else {
                                setTitleKeyword("");
                            }
                            if (filter.ItemContent != null && filter.ItemContent !== "") {
                                //hightlight item content
                                setItemContentKeyword(JSON.parse(filter.ItemContent));
                            } else {
                                setItemContentKeyword("");
                            }
                        }}
                        onGeneralSearch={keyword => {
                            setGeneralSearchKeyword(keyword);
                        } }
                        actions={[
                            {
                                component: d => <button className="ro-button" onClick={_ => {
                                    setModalOpen(true);
                                    getExcerpt(d.data.Id);
                                    getMembers(d.data.Id);
                                }}>
                                    <span>
                                        View Details
                                    </span>
                                </button>
                            }
                        ]}
                    />
                </>
        }
    </>
}

export default Legislations;